import { useEffect, useRef } from 'react';

import { DEFAULT_CLIENT_NAME } from '~/types/client/Client';
import { IClient } from '~/types/client/IClient';

const APP_TITLE = 'Unboared';

/**
 * Onglet du navigateur : « Nom du lieu - Unboared » (accueil et session TV),
 * jamais l'identifiant Firestore, illisible. « Unboared » seul tant que le bon
 * client n'est pas chargé : après un changement de lieu, useSyncClient renvoie
 * encore l'ancien client jusqu'au nouvel instantané. On écarte donc l'objet
 * présent au moment du changement (le champ `id` du document n'est pas garanti).
 * Remis à « Unboared » en quittant la page, pour ne pas nommer un lieu ailleurs.
 */
export function useVenueTitle(clientID: string, client: IClient | undefined) {
    const atSwitch = useRef({ clientID, client: undefined as IClient | undefined });
    if (atSwitch.current.clientID !== clientID) atSwitch.current = { clientID, client };
    const loaded = client && client !== atSwitch.current.client ? client : undefined;

    const name = clientID === 'demo' ? 'Demo' : loaded?.name?.trim();
    const venueName = name && name !== DEFAULT_CLIENT_NAME ? name : undefined;

    useEffect(() => {
        document.title = venueName ? `${venueName} - ${APP_TITLE}` : APP_TITLE;
        return () => {
            document.title = APP_TITLE;
        };
    }, [venueName]);
}
